<button
  matIconButton
  aria-label="Click"
  [class.mat-icon-selected]="buttonToolSelected$() == 'click'"
  [matTooltip]="
    selectionScaleService.currentScaleLevel$()?.displayName != hectare
      ? 'Select area'
      : 'Move on map'
  "
  (click)="selectionToolService.selectDrawTool('click')"
  [disabled]="calculationModuleService.isCMRunning$() || scenarioService.isDataLoading$()"
>
  <mat-icon class="material-symbols-outlined">arrow_selector_tool</mat-icon>
</button>
<!-- {{ selectionToolService.theDrawer.options == '{}' }} -->
<button
  matIconButton
  aria-label="Rectangle"
  [class.mat-icon-selected]="buttonToolSelected$() == 'rectangle'"
  matTooltip="Draw rectangle area"
  (click)="selectionToolService.selectDrawTool('rectangle')"
  [disabled]="calculationModuleService.isCMRunning$() || scenarioService.isDataLoading$()"
>
  <mat-icon>square</mat-icon>
</button>
<button
  matIconButton
  aria-label="Circle"
  [class.mat-icon-selected]="buttonToolSelected$() == 'circle'"
  matTooltip="Draw circle area"
  (click)="selectionToolService.selectDrawTool('circle')"
  [disabled]="calculationModuleService.isCMRunning$() || scenarioService.isDataLoading$()"
>
  <mat-icon>circle</mat-icon>
</button>
<button
  matIconButton
  aria-label="Polygon"
  [class.mat-icon-selected]="buttonToolSelected$() == 'polygon'"
  matTooltip="Draw polygon area"
  (click)="selectionToolService.selectDrawTool('polygon')"
  [disabled]="calculationModuleService.isCMRunning$() || scenarioService.isDataLoading$()"
>
  <mat-icon>hexagon</mat-icon>
</button>

<div matTooltip="Upload geojson file (only at hectare)">
  <button
    matIconButton
    aria-label="Upload geojson"
    [disabled]="
      selectionScaleService.currentScaleLevel$()?.displayName != hectare ||
      calculationModuleService.isCMRunning$() ||
      scenarioService.isDataLoading$()
    "
    (click)="fileInput.click()"
  >
    <mat-icon>upload_file</mat-icon>
    <input
      hidden
      (change)="uploadShapes($event)"
      #fileInput
      type="file"
      accept=".geojson"
      id="file"
    />
  </button>
</div>

<div matTooltip="Clear selection">
  <button
    matIconButton
    aria-label="Clear"
    [class.icon-button-warn]="
      !isClearBtnDisabled$() &&
      !(calculationModuleService.isCMRunning$() || scenarioService.isDataLoading$())
    "
    [disabled]="
      isClearBtnDisabled$() ||
      calculationModuleService.isCMRunning$() ||
      scenarioService.isDataLoading$()
    "
    (click)="clearLayers()"
  >
    <mat-icon>deselect</mat-icon>
  </button>
</div>
